// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2WXT-","error":"Textarea_error__2h8dc","readonly":"Textarea_readonly__35tMF","disabled":"Textarea_disabled__1p0Gg"};